export default {"src":"/_next/static/media/info.c3443d3d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};